import { UserCircle, UserRoundCheck, UserRoundX } from 'lucide-react';
import React, { useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri';

const ActiveInactiveCustomerList = () => {
    const [customerType, setCustomerType] = useState('Active');
    const [withInsurance, setWithInsurance] = useState({
        life: false,
        health: false,
        motor: false,
        other: false,
    });
    const [withoutInsurance, setWithoutInsurance] = useState({
        life: false,
        health: false,
        motor: false,
        other: false,
    });

    const handleCheckboxChange = (type, category) => {
        if (category === 'with') {
            setWithInsurance((prev) => ({ ...prev, [type]: !prev[type] }));
        } else {
            setWithoutInsurance((prev) => ({ ...prev, [type]: !prev[type] }));
        }
    };

    return (
        <div className="container p-6">

            <div className="flex justify-between items-center border-b border-brandRed pb-2 mb-4">
                <div>
                    <h5 className="text-brandRed font-bold">Active Inactive Customer List</h5>
                </div>

                <div className="flex gap-3">
                    <div><RiFileExcel2Line size={30} /></div>
                </div>
            </div>

            {/* Tabs */}
            <div className="flex mb-6 gap-8">
                {/* Active Customer */}
                <div className="flex flex-col items-center">
                    <UserRoundCheck className="w-6 h-6 text-green-600 mb-1" />
                    <button
                        type="button"
                        className={`toggle-btn ${customerType === "Active" ? "active" : ""}`}
                        onClick={() => setCustomerType('Active')}
                    >
                        Active Customers
                    </button>
                </div>

                {/* Inactive Customer */}
                <div className="flex flex-col items-center">
                    <UserRoundX className="w-6 h-6 text-red-600 mb-1" />
                    <button
                        type="button"
                        className={`toggle-btn ${customerType === "Inactive" ? "active" : ""}`}
                        onClick={() => setCustomerType('Inactive')}
                    >
                        In-Active Customers
                    </button>
                </div>
            </div>


            {/* Filters */}
            <div className="space-y-4 mb-6">
                {/* Filters */}
                <div className="space-y-4 mb-6">
                    {[
                        { label: "Customer With", state: withInsurance, category: "with" },
                        { label: "Customer Without", state: withoutInsurance, category: "without" },
                    ].map((section, idx) => (
                        <div
                            key={idx}
                            className="grid grid-cols-[150px_repeat(4,_minmax(120px,_1fr))] items-center gap-4"
                        >
                            <span className="font-medium">{section.label}</span>
                            {["life", "health", "motor", "other"].map((type) => (
                                <label
                                    key={type}
                                    className="flex items-center space-x-2 capitalize text-gray-700"
                                >
                                    <input
                                        type="checkbox"
                                        checked={section.state[type]}
                                        onChange={() => handleCheckboxChange(type, section.category)}
                                    />
                                    <span>{type === "life" ? "Life Insurance" : type}</span>
                                </label>
                            ))}
                        </div>
                    ))}
                </div>
            </div>

            {/* Table */}
            <div className="overflow-x-auto">
                <table className="w-full table-auto border border-gray-300">
                    <thead className="bg-gray-100">
                        <tr>
                            <th className="border px-2 py-1"></th>
                            <th className="border px-2 py-1 text-center">Group Code</th>
                            <th className="border px-2 py-1 text-center">Customer Name</th>
                            <th className="border px-2 py-1 text-center">Life</th>
                            <th className="border px-2 py-1 text-center">Health</th>
                            <th className="border px-2 py-1 text-center">Motor</th>
                            <th className="border px-2 py-1 text-center">Other</th>
                        </tr>
                    </thead>
                    <tbody>
                        {[1, 2].map((_, index) => (
                            <tr key={index} className="text-center">
                                <td className="border px-2 py-1">
                                    <input type="checkbox" />
                                </td>
                                <td className="border px-2 py-1">

                                </td>
                                <td className="border px-2 py-1">

                                </td>
                                {['life', 'health', 'motor', 'other'].map((type) => (
                                    <td key={type} className="border px-2 py-1">
                                        <input type="checkbox" />
                                    </td>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default ActiveInactiveCustomerList;
